/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Security_Totp_Algorithm_Sha1Inputs */



/**
* | output |
* | --- |
* | "SHA-1" |
*
* @param {Profile_Security_Totp_Algorithm_Sha1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_security_totp_algorithm_sha1 = /** @type {((inputs?: Profile_Security_Totp_Algorithm_Sha1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Security_Totp_Algorithm_Sha1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("SHA-1")
	return /** @type {LocalizedString} */ ("SHA-1")
});